/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathEqualGreater = createReactComponent(
  "math-equal-greater",
  "IconMathEqualGreater",
  [
    ["path", { d: "M5 18l14 -4", key: "svg-0" }],
    ["path", { d: "M5 14l14 -4l-14 -4", key: "svg-1" }]
  ]
);

export { IconMathEqualGreater as default };
//# sourceMappingURL=IconMathEqualGreater.js.map
